import { Injectable } from '@angular/core';
import { MenuItem } from './layouts/horizontaltopbar/menu.model';
@Injectable({
    providedIn: 'root'
  })
export class Globals{
    menus: MenuItem[] = [];


    getMenu() {
        return this.menus;
      }

      setMenu(menus : MenuItem[] ){
        this.menus = menus;
      }
}